import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ATMO } from "@/config/site";

const MATERIALS = [
  {
    key: "gruen",
    label: "Grün",
    img: ATMO.gruen,
    text: "Rasen, Gräser, Hecken und Stauden – lebendige Flächen, die den Raum tragen.",
  },
  {
    key: "stein",
    label: "Stein",
    img: ATMO.stein,
    text: "Naturstein und Platten geben Ruhe, Struktur und dauerhafte Nutzbarkeit.",
  },
  {
    key: "holz",
    label: "Holz",
    img: ATMO.holz,
    text: "Warme Oberflächen für Sitzplätze, Decks und Übergänge ins Grüne.",
  },
  {
    key: "licht",
    label: "Licht",
    img: ATMO.licht,
    text: "Dezente Beleuchtung verlängert den Garten in den Abend hinein.",
  },
];

export const GardenMaterials = () => {
  const [active, setActive] = useState(0);
  const current = MATERIALS[active];

  return (
    <section
      data-testid="materials-section"
      className="relative h-[86svh] min-h-[560px] overflow-hidden bg-[#17251C]"
    >
      <AnimatePresence mode="sync">
        <motion.img
          key={current.key}
          src={current.img}
          alt={`${current.label} als Gestaltungsmaterial im Garten`}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </AnimatePresence>
      <div className="absolute inset-0 bg-[#17251C]/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#17251C] via-[#17251C]/45 to-[#17251C]/55" />

      <div className="relative mx-auto flex h-full max-w-[1480px] flex-col justify-between px-5 py-20 md:px-10 md:py-24">
        <div>
          <p className="eyebrow !text-[#DCCDB4]">Gartenraum</p>
          <h2 className="display-xl mt-4 max-w-2xl text-[9vw] leading-[0.9] text-[#F3EDE2] md:text-[4.4vw]">
            Wir gestalten Räume.
          </h2>
        </div>

        <div>
          <AnimatePresence mode="wait">
            <motion.p
              key={current.key}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.5 }}
              className="mb-8 max-w-md rounded-2xl bg-[#17251C]/45 px-5 py-4 text-sm leading-relaxed text-[#F3EDE2] backdrop-blur-md md:text-base"
            >
              {current.text}
            </motion.p>
          </AnimatePresence>

          <div className="flex flex-wrap gap-x-8 gap-y-3 md:gap-x-16">
            {MATERIALS.map((m, i) => (
              <button
                key={m.key}
                type="button"
                data-testid={`material-${m.key}`}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className="group relative text-left"
              >
                <span
                  className={`display-xl block text-[10vw] leading-none transition-all duration-500 md:text-[4.6vw] ${
                    active === i ? "text-[#F3EDE2]" : "text-[#F3EDE2]/55 hover:text-[#F3EDE2]/85"
                  }`}
                  style={{ textShadow: "0 4px 24px rgba(23,37,28,0.55)" }}
                >
                  {m.label}
                </span>
                <span
                  className={`mt-2 block h-[2px] bg-[#B4623C] transition-all duration-500 ${
                    active === i ? "w-full" : "w-0"
                  }`}
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
